<template>
  <div class="row-flight-header">
    <div class="cell sortable align-left id" @click="updateSort('id')">
      <div class="header-title" :class="[{'sorting': sort == 'id'}, direction]">{{ $t("airportTable.id") }}</div>
    </div>
    <div class="cell sortable align-left airline" @click="updateSort('airline')">
      <div class="header-title" :class="[{'sorting': sort == 'airline'}, direction]">{{ $t("airportTable.airline") }}</div>
    </div>
    <div class="cell sortable align-center airlineCode" @click="updateSort('airlineCode')">
      <div class="header-title" :class="[{'sorting': sort == 'airlineCode'}, direction]">{{ $t("airportTable.code") }}</div>
    </div>
    <div class="cell sortable align-center flightNumber" @click="updateSort('flightNumber')">
      <div class="header-title" :class="[{'sorting': sort == 'flightNumber'}, direction]">{{ $t("airportTable.number") }}</div>
    </div> 
    <div class="cell sortable align-center flightType has-header-tooltip" @click="updateSort('flightType')">
      <div class="header-title" :class="[{'sorting': sort == 'flightType'}, direction]">{{ $t("airportTable.a/d") }}</div>
      <span class="header-tooltip" role="tooltip">{{ $t("airportTable.a/dTooltip") }}</span>
    </div>
    <div class="cell sortable align-center city" @click="updateSort('city')">
      <div class="header-title" :class="[{'sorting': sort == 'city'}, direction]">{{ $t("airportTable.city") }}</div>
    </div>
    <div
      class="cell sortable align-center sdtDate has-header-tooltip header-cell--stacked"
      :class="[{'sorting': sort == 'sdtDate'}, direction]"
      @click="updateSort('sdtDate')"
    >
      <div class="header-sort-layout">
        <span class="sort-icon sort-icon--up mdi mdi-menu-up" aria-hidden="true"></span>
        <div class="header-label header-label--stacked">
          <span class="stacked-line">{{ $t("airportTable.sdtDateLine1") }}</span>
          <span class="stacked-line">{{ $t("airportTable.sdtDateLine2") }}</span>
        </div>
        <span class="sort-icon sort-icon--down mdi mdi-menu-down" aria-hidden="true"></span>
      </div>
      <span class="header-tooltip" role="tooltip">{{ $t("airportTable.sdtDateTooltip") }}</span>
    </div>
    <div class="cell sortable align-center scheduled has-header-tooltip" @click="updateSort('scheduled')">
      <div class="header-title" :class="[{'sorting': sort == 'scheduled'}, direction]">{{ $t("airportTable.sdt") }}</div>
      <span class="header-tooltip" role="tooltip">{{ $t("airportTable.sdtTooltip") }}</span>
      </div>
    <div class="cell sortable align-center estimated has-header-tooltip" @click="updateSort('estimated')">
      <div class="header-title" :class="[{'sorting': sort == 'estimated'}, direction]">{{ $t("airportTable.edt") }}</div>
      <span class="header-tooltip" role="tooltip">{{ $t("airportTable.edtTooltip") }}</span>
    </div>
    <div class="cell sortable align-center gate" @click="updateSort('gate')">
      <div class="header-title" :class="[{'sorting': sort == 'gate'}, direction]">{{ $t("airportTable.gate") }}</div>
    </div>
    <div class="cell sortable align-center claim" @click="updateSort('claim')">
      <div class="header-title" :class="[{'sorting': sort == 'claim'}, direction]">{{ $t("airportTable.claim") }}</div>
    </div>
    <div class="cell sortable align-center status" @click="updateSort('status')">
      <div class="header-title" :class="[{'sorting': sort == 'status'}, direction]">{{ $t("airportTable.status") }}</div>
    </div>
    <div class="cell align-center">
      <div class="header-title">{{ $t("airportTable.remark") }}</div>
    </div>
    <div class="cell align-center action" v-if="this.permissions.includes('Edit-Flight-Details')">
      <div class="header-title">{{ $t("airportTable.action") }}</div>
    </div>
  </div>
</template>

<script>
import { getPermissions } from '../js/utils/userContext';

export default {
  name: 'RowActiveFlightHeader',
  props:  {
    direction: String,
    sort: String
  },
  computed: {
    permissions() {
      return getPermissions();
    }
  },
  methods: {
    updateSort(value) {
      this.$emit('updateSort', value);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../styles/portal-tooltip';

  .row-flight-header {
    width: 100%;
    height: 50px;
    background-color: $brand-primary-dark;
    background: linear-gradient(135deg, $brand-primary-dark 0%, $brand-primary 55%, $brand-primary-mid 100%);
    position: sticky;
    top: 0;
    z-index: 2;
    display: flex;
    border-radius: 8px 8px 0 0;
    box-shadow: 0 2px 8px rgba($brand-primary-dark, 0.3);
    overflow: visible;

    .cell {
      height: 100%;
      padding: 0 20px;
      position: relative;
      float: left;
      color: rgba(255, 255, 255, 0.95);
      font-weight: 700;
      font-size: 12px;
      text-transform: uppercase;
      letter-spacing: 0.04em;
      line-height: 1.2em;
      flex-basis: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;

      .header-title {
        width: auto;
        height: auto;
        position: relative;
        user-select: none;

        &:before, &:after {
          width: 100%;
          height: auto;
          left: 0;
          position: absolute;
          text-align: center;
          color: transparent;

          display: flex;
          align-items: center;
          justify-content: center;  
          
          font: normal normal normal 24px/1 'Material Design Icons';
        }

        &:before {
          top: -20px;
          content: '\F0360';          
        }

        &:after {
          top: 9px;
          content: '\F035D';       
        }

      }

      &.has-header-tooltip {
        overflow: visible;
        @include portal-hover-tooltip-trigger('header-tooltip', center);
        @include portal-hover-tooltip-bubble('header-tooltip', center);
      }

      &.sortable {
        cursor: pointer;
      }

      &.sortable:hover .header-title:before, &.sortable:hover .header-title:after {
        color: rgba(255, 255, 255, 0.85);
      }

      .sorting, .sorting.descending:before, .sorting.ascending:after {
        color: #ffd966 !important;
      }

      &.id {
        min-width: 80px;
        max-width: 80px;
      }

      &.airline {
        min-width: 240px;
        max-width: 240px;
      }

      &.flightType {
        max-width: 60px;
      }

      &.airlineCode, &.flightNumber, &.scheduled, &.estimated, &.gate, &.claim, &.action {
        min-width: 80px;
        max-width: 120px;
      }

      &.sdtDate {
        min-width: 104px;
        max-width: 104px;
        overflow: visible;

        .header-sort-layout {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 100%;
          width: 100%;
          user-select: none;
        }

        .header-label--stacked {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          line-height: 1.1;
          gap: 1px;
          padding: 1px 0;
        }

        .stacked-line {
          display: block;
          font-size: inherit;
          font-weight: inherit;
          letter-spacing: inherit;
          text-transform: inherit;
        }

        .sort-icon {
          font-size: 16px;
          line-height: 1;
          height: 10px;
          color: transparent;
          flex-shrink: 0;
        }
      }

      &.header-cell--stacked.sortable:hover .sort-icon {
        color: rgba(255, 255, 255, 0.85);
      }

      &.header-cell--stacked.sorting.descending .sort-icon--up,
      &.header-cell--stacked.sorting.ascending .sort-icon--down {
        color: #ffd966 !important;
      }

      &.city {
        min-width: 200px;
        max-width: 200px;
      }

      &.status {
        min-width: 140px;
        max-width: 140px;
      }

      &.align-left {
        justify-content: flex-start;
        text-align: left;
      }

      &.align-center {
        justify-content: center;
        text-align: center;
      }

      &.align-right {
        justify-content: flex-end;
        text-align: right;
      }
    }
  }

  /* Responsive tweaks to align header with row sizing for laptop screens */
  @media screen and (max-width: 1600px) {
    .row-flight-header {
      .cell {
        font-size: 11px;
        padding: 0 16px;
        &.id { min-width: 70px; max-width: 70px; }
        &.airline { min-width: 220px; max-width: 220px; }
        &.city { min-width: 190px; max-width: 190px; }
        &.airlineCode, &.flightNumber, &.scheduled, &.estimated, &.gate, &.claim, &.action {
          min-width: 75px; max-width: 110px;
        }
        &.sdtDate { min-width: 100px; max-width: 100px; }
        &.status { min-width: 130px; max-width: 130px; }
        &.scheduled, &.estimated {
          .header-title {
            font-size: 10px;
            white-space: nowrap;
            line-height: 1.1;
          }
        }

        &.sdtDate .header-label--stacked {
          font-size: 10px;
        }
      }
    }
  }

  @media screen and (max-width: 1366px) {
    .row-flight-header {
      height: 46px;
      .cell {
        font-size: 10px;
        padding: 0 12px;
        &.id { min-width: 64px; max-width: 64px; }
        &.airline { min-width: 200px; max-width: 200px; }
        &.city { min-width: 170px; max-width: 170px; }
        &.airlineCode, &.flightNumber, &.scheduled, &.estimated, &.gate, &.claim, &.action {
          min-width: 68px; max-width: 100px;
        }
        &.sdtDate { min-width: 96px; max-width: 96px; }
        &.status { min-width: 120px; max-width: 120px; }
        &.scheduled, &.estimated {
          .header-title {
            font-size: 9px;
            white-space: nowrap;
            line-height: 1.1;
          }
        }

        &.sdtDate .header-label--stacked {
          font-size: 9px;
        }
      }
    }
  }
</style>
